module.exports = __webpack_public_path__ + "static/media/jupyter.41a4f867.png";